import React from 'react';
import './Card.css';

function ChineseCard({ sign, onClick }) {
  return (
    <div
      className="fortune-card"
      style={{ borderColor: sign.color }}
      onClick={() => onClick(sign)}
    >
      <div className="card-emoji" style={{ color: sign.color }}>
        {sign.emoji}
      </div>
      <h3 className="card-title">{sign.name}</h3>
      <p className="card-years">{sign.years}</p>
    </div>
  );
}

export default ChineseCard;
